export const getSiteByUserId = (
  host: string,
  apiky: string,
  token: string,
  userId: number
) => {
  const reqestURL = `${host}/sites/list?user_id=${userId}`;
  const reqestHeader: HeadersInit = new Headers();
  reqestHeader.set("Content-Type", "application/json");
  reqestHeader.set("Client-Service", "frontend-client");
  reqestHeader.set("Auth-Key", apiky);
  reqestHeader.set("Authorization", token);
  reqestHeader.set("User-ID", `${userId}`);

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader
  })
    .then(response => response.json())
    .then(response => {
      let msLayerList = [];
      if (Array.isArray(response.data)) {
        msLayerList = response.data;
      } else {
        msLayerList = [response.data];
      }
      return msLayerList;
    })
    .catch(error => {
      return error;
    });
};
